import { Preview } from "@creatomate/preview";
import { ElementSource } from "chq";
import isSubtitleText from "./isSubtitleText";

const hideSubtitlesElements = async (
  preview: Preview
) => {
  // Remove current subtitles
  // Update source to avoid undo/redo actions here
  const source = preview.getSource();
  await preview.setSource({
    ...source,
    elements: source.elements.map((element: ElementSource) => {
      if (isSubtitleText(element.name)) {
        return { ...element, visible: false };
      }
      return element;
    })
  }, false);
};

export default hideSubtitlesElements;
